export const typeOptions = [
    { value: 'Arrangement Drawing (Equipment)', label: 'Arrangement Drawing (Equipment)' },
    { value: 'Assembly Drawing', label: 'Assembly Drawing' },
    { value: 'Audit', label: 'Audit' },
    { value: 'Basis of Design', label: 'Basis of Design' },
    { value: 'Bill of Material', label: 'Bill of Material' },
    { value: 'Block Diagram', label: 'Block Diagram' },
    { value: 'Cable Routing Diagram', label: 'Cable Routing Diagram' },
    { value: 'Cable Schedule', label: 'Cable Schedule' },
    { value: 'Calculation', label: 'Calculation' },
    { value: 'Cause & Effect Diagram', label: 'Cause & Effect Diagram' },
    { value: 'Certificate', label: 'Certificate' },
    { value: 'Change notice', label: 'Change notice' },
    { value: 'Commercial Bid Evaluation', label: 'Commercial Bid Evaluation' },
    { value: 'Commissioning Report', label: 'Commissioning Report' },
    { value: 'Contract', label: 'Contract' },
    { value: 'Correspondance', label: 'Correspondance' },
    { value: 'Customer Data', label: 'Customer Data' },
    { value: 'Daily Progress Report', label: 'Daily Progress Report' },
    { value: 'Date Sheet', label: 'Date Sheet' },
    { value: 'Design Change Notification', label: 'Design Change Notification' },
    { value: 'Design Statement', label: 'Design Statement' },
    { value: 'Detail Drawing', label: 'Detail Drawing' },
    { value: 'Dossier', label: 'Dossier' },
    { value: 'Equipment List', label: 'Equipment List' },
    { value: 'Estimate', label: 'Estimate' },
    { value: 'Flowchart', label: 'Flowchart' },
    { value: 'Form of Tender', label: 'Form of Tender' },
    { value: 'Foundation Drawing', label: 'Foundation Drawing' },
    { value: 'Handover', label: 'Handover' },
    { value: 'Hazardous Area Classification Drawing', label: 'Hazardous Area Classification Drawing' },
    { value: 'HAZID Report', label: 'HAZID Report' },
    { value: 'Health and Safety Report', label: 'Health and Safety Report' },
    { value: 'Heat and Material Balance', label: 'Heat and Material Balance' },
    { value: 'Hook-up Drawing', label: 'Hook-up Drawing' },
    { value: 'Index', label: 'Index' },
    { value: 'Inspection', label: 'Inspection' },
    { value: 'Test Plan', label: 'Test Plan' },
    { value: 'Inspection Report', label: 'Inspection Report' },
    { value: 'Interface Document', label: 'Interface Document' },
    { value: 'Lifting Plan', label: 'Lifting Plan' },
    { value: 'Line List', label: 'Line List' },
    { value: 'List', label: 'List' }
];

export const disciplineOptions = [
  { value: 'ADM - Administration Management', label: 'ADM - Administration Management' },
  { value: 'CAD - Service & Graphics', label: 'CAD - Service & Graphics' },
  { value: 'CED - Cryo Vessels Engineering & Design', label: 'CED - Cryo Vessels Engineering & Design' },
  { value: 'CIS - Civil', label: 'CIS - Civil' },
  { value: 'COM - Commissioning & Start-up', label: 'COM - Commissioning & Start-up' },
  { value: 'CON - Construction', label: 'CON - Construction' },
  { value: 'CPI - Cryo Piping', label: 'CPI - Cryo Piping' },
  { value: 'BMS - Document Management', label: 'BMS - Document Management' },
  { value: 'EHS - Environment,Health & Safety', label: 'EHS - Environment,Health & Safety' },
  { value: 'ELE - Electrical', label: 'ELE - Electrical' },
  { value: 'HVAS - Heating,Ventilation & Air Conditioning', label: 'HVAS - Heating,Ventilation & Air Conditioning' },
  { value: 'MCN - Machinery', label: 'MCN - Machinery' },
  { value: 'MED - Mechanical Vessels Engineering Design', label: 'MED - Mechanical Vessels Engineering Design' },
  { value: 'MFT - Manufacturing', label: 'MFT - Manufacturing' },
  { value: 'MSE - Mechanical Systems Engineering', label: 'MSE - Mechanical Systems Engineering' },
  { value: 'PCE - Process Control & Instruments', label: 'PCE - Process Control & Instruments' },
  { value: 'PCS - Process', label: 'PCS - Process' },
  { value: 'PEM - Project Engineering Management', label: 'PEM - Project Engineering Management' },
  { value: 'PIP - Piping', label: 'PIP - Piping' },
  { value: 'PRC - Project Controls', label: 'PRC - Project Controls' },
  { value: 'PRJ - Projects', label: 'PRJ - Projects' },
];

export const statusOptions = [
  { value: 'Accepted', label: 'Accepted' },
  { value: 'As Built', label: 'As Built' },
  { value: 'Closed', label: 'Closed' },
  { value: 'Code 1', label: 'Code 1' },
  { value: 'Code 2', label: 'Code 2' },
  { value: 'Code 3', label: 'Code 3' },
  { value: 'Code 4', label: 'Code 4' },
  { value: 'Code 5', label: 'Code 5' },
  { value: 'Draft', label: 'Draft' },
  { value: 'For Approval', label: 'For Approval' },
  { value: 'For Construction', label: 'For Construction' },
  { value: 'For Design', label: 'For Design' },
  { value: 'For Information', label: 'For Information' },
  { value: 'For Project Execution', label: 'For Project Execution' },
  { value: 'For Review', label: 'For Review' },
  { value: 'IDSC', label: 'IDSC' },
  { value: 'In Progress', label: 'In Progress' },
  { value: 'Issued', label: 'Issued' },
  { value: 'No longer in Use', label: 'No longer in Use' },
  { value: 'Not Started', label: 'Not Started' },
  { value: 'Open', label: 'Open' },
  { value: 'Preliminary', label: 'Preliminary' },
  { value: 'Redline Mark Up', label: 'Redline Mark Up' },
  { value: 'Rejected', label: 'Rejected' },
  { value: 'Reserved', label: 'Reserved' },
  { value: 'Resubmit', label: 'Resubmit' },
  { value: 'Reviewed', label: 'Reviewed' },
  { value: 'Reviewed with Comments', label: 'Reviewed with Comments' },
  { value: 'Superseded', label: 'Superseded' },
  { value: 'Under Review', label: 'Under Review' },
  { value: 'Under Workflow Review', label: 'Under Workflow Review' },
  { value: 'Void', label: 'Void' },
];

export const equipmentTagOptions = [
  { value: 'Auxiliary Transformer', label: 'Auxiliary Transformer' },
  { value: 'Power Transformer', label: 'Power Transformer' },
  { value: 'CVT', label: 'CVT' },
  { value: 'DS/ES', label: 'DS/ES' },
  { value: 'DTCB', label: 'DTCB' },
  { value: 'ES', label: 'ES' },
  { value: 'Surge Arrestor', label: 'Surge Arrestor' },
  { value: 'Earthing Transformer', label: 'Earthing Transformer' },
  { value: 'Emergency DG', label: 'Emergency DG' },
  { value: 'Automatic Cleaning Robots', label: 'Automatic Cleaning Robots' },
  { value: 'Auxiliary Systems', label: 'Auxiliary Systems' },
  { value: 'Civil Work Package', label: 'Civil Work Package' },
  { value: 'Combiner Box', label: 'Combiner Box' },
  { value: 'Control & Protection Panels', label: 'Control & Protection Panels' },
  { value: 'Culverts', label: 'Culverts' },
  { value: 'DC-DC Converter', label: 'DC-DC Converter' },
  { value: 'Distribution Panels', label: 'Distribution Panels' },
  { value: 'Drainage', label: 'Drainage' },
  { value: 'Earthing System', label: 'Earthing System' },
  { value: 'EMS Package', label: 'EMS Package' },
  { value: 'FDP', label: 'FDP' },
  { value: 'Fence & Gate', label: 'Fence & Gate' },
  { value: 'Fiber Optic Cable', label: 'Fiber Optic Cable' },
  { value: 'Fire Alarm Panels', label: 'Fire Alarm Panels' },
  { value: 'HVAC Control Panels', label: 'HVAC Control Panels' },
  { value: 'Inverter Skids', label: 'Inverter Skids' },
  { value: 'Lighting System', label: 'Lighting System' },
  { value: 'LV AC Cable', label: 'LV AC Cable' },
  { value: 'LV DC Cable', label: 'LV DC Cable' },
  { value: 'FO Cable', label: 'FO Cable' },
  { value: 'Medium Voltage Switch Gear Package', label: 'Medium Voltage Switch Gear Package' },
  { value: 'MV Cable', label: 'MV Cable' },
  { value: 'MV SWGR Panel', label: 'MV SWGR Panel' },
  { value: 'NGR', label: 'NGR' },
  { value: 'Roads', label: 'Roads' },
  { value: 'SCADA', label: 'SCADA' },
  { value: 'Solar Tracker', label: 'Solar Tracker' },
  { value: 'STATCOM', label: 'STATCOM' },
  { value: 'Weather Monitoring Station', label: 'Weather Monitoring Station' },
];


export const releasePurposeOptions = [
  { value: 'ASB - As Built', label: 'ASB - As Built' },
  { value: 'CON - Issue for Contract', label: 'CON - Issue for Contract' },
  { value: 'ICR - Issued for Client Review', label: 'ICR - Issued for Client Review' },
  { value: 'IEN - Issued for Engineering', label: 'IEN - Issued for Engineering' },
  { value: 'IES - Issued for Estimate', label: 'IES - Issued for Estimate' },
  { value: 'IFB - Issued for Bid', label: 'IFB - Issued for Bid' },
  { value: 'IFC - Issued for Construction', label: 'IFC - Issued for Construction' },
  { value: 'IDF - Issued for Design', label: 'IDF - Issued for Design' },
  { value: 'IFE - Issued for Enquiry', label: 'IFE - Issued for Enquiry' },
  { value: 'IFI - Issued for Information', label: 'IFI - Issued for Information' },
  { value: 'IFP - Issued for Purchase', label: 'IFP - Issued for Purchase' },
  { value: 'IFIR - Issued for Internal Review', label: 'IFIR - Issued for Internal Review' },
  { value: 'IFR - Issued for Review', label: 'IFR - Issued for Review' },
  { value: 'IFT - Issued for Tender', label: 'IFT - Issued for Tender' },
  { value: 'IPE - Issued for Project Execution', label: 'IPE - Issued for Project Execution' },
  { value: 'IFCR - Issued for Client Review', label: 'IFCR - Issued for Client Review' },
  { value: 'PRE - Preliminary', label: 'PRE - Preliminary' },
  { value: 'RES - Reserved', label: 'RES - Reserved' },
  { value: 'SSD - Superseded', label: 'SSD - Superseded' },
  { value: 'VOI - Void', label: 'VOI - Void' },
];


export const organizationCodeOptions = [
  { value: 'ABB', label: 'ABB' },
  { value: 'AMCE FLUID SYSTEMS', label: 'AMCE FLUID SYSTEMS' },
  { value: 'ACUTECH CONSULTING', label: 'ACUTECH CONSULTING' },
  { value: 'SAUDI CONSOLIDATED ENGINEERING COMPANY', label: 'SAUDI CONSOLIDATED ENGINEERING COMPANY' },
];


export const unitCodeOptions = [
  { value: '000 - General', label: '000 - General' },
  { value: '500 - Generation Common', label: '500 - Generation Common' },
  { value: '510 - BESS BOP', label: '510 - BESS BOP' },
  { value: '511 - BESS Pooling Station', label: '511 - BESS Pooling Station' },
  { value: '512 - Battery Containers', label: '512 - Battery Containers' },
  { value: '530 - Solar General', label: '530 - Solar General' },
  { value: '531 - PV Group 1', label: '531 - PV Group 1' },
  { value: '532 - PV Group 2', label: '532 - PV Group 2' },
  { value: '533 - PV Group 3', label: '533 - PV Group 3' },
  { value: '534 - Solar Pooling 1', label: '534 - Solar Pooling 1' },
  { value: '535 - Solar Pooling 2', label: '535 - Solar Pooling 2' },
  { value: '536 - Solar Pooling 3', label: '536 - Solar Pooling 3' },
];

export const elementOptions = [
  { value: 'General', label: 'General' },
  { value: 'GHE - Green Hydrogen Element', label: 'GHE - Green Hydrogen Element' },
  { value: 'PEG - Power Element Grid', label: 'PEG - Power Element Grid' },
  { value: 'PEDR - Power Element Grid', label: 'PEDR - Power Element Grid' },
  { value: 'PM210011:NGHP- Green Hydrogen Elements(GHE)', label: 'PM210011:NGHP- Green Hydrogen Elements(GHE)' },
  { value: 'PM210012:NGHP- Power Elements(PWE)', label: 'PM210012:NGHP- Power Elements(PWE)' },
  { value: 'PM210060:NGHP- Overarching', label: 'PM210060:NGHP- Overarching' },
];

export const documentClassOptions = [
  { value: 'Class 1 - For Approval', label: 'Class 1 - For Approval' },
  { value: 'Class 2 - For Review', label: 'Class 2 - For Review' },
  { value: 'Class 3 - For Information', label: 'Class 3 - For Information' },
];

export const oTIntegrationSystemOptions = [
  { value: 'Superseded from OT', label: 'Superseded from OT' },
  { value: 'To be transferred to Open Text', label: 'To be transferred to Open Text' },
  { value: 'To be transferred to Open Text - All Revisions', label: 'To be transferred to Open Text - All Revisions' },
  { value: 'Transferred from OT', label: 'Transferred from OT' },
];



